 
  import { Injectable } from '@angular/core';
  import { errorMessages } from "../../settings";
  import { CommonService } from "../common.service";
  import { WidgethelperService } from "../widgethelper.service";
  import { BaseService } from "./base.service";
  import { WidgetCriteria } from "../../models/DataModels";
  import * as _ from "lodash";
  
  @Injectable()
  export class CubbystatusdashboardService extends BaseService {
  
    constructor( private _commonService: CommonService,
      private _widgetHelper: WidgethelperService) {    
      super();
    }
  
    colorCodes = [];
    init(widget: any) {
      this.colorCodes = this._commonService.getColorCodes();
      this._widgetHelper.CreateHub(widget)
      this.DisplayData(widget);
    }
  
    DisplayData(widget: any) {
      widget.hub.listenFor("broadcastCubbyOrderStatus").subscribe(
        (data: any) => {          
          let result: Array<any> = [];
          result = data;
          let resultwid;
          let resultcreationtime;
          let lastUpdatedTime;
  
          let criteria = widget.widgetsettings && widget.widgetsettings.Criteria ?
          JSON.parse(widget.widgetsettings.Criteria) : {WaveStatusType:''};
          criteria.WaveStatusActive = criteria.WaveStatusActive ? criteria.WaveStatusActive : 'ACTIVE';
          switch(criteria.WaveStatusType){
            case "INDIVIDUAL PUTWALL" :
                widget.Title = "Individual Put Wall Cubby Status - " + criteria.WaveStatusActive + " PUTWALL"; 
                break;   
              default :
                widget.Title = "All Cubby Status - " + criteria.WaveStatusActive + " PUTWALL";      
              break;
          }
  
          if (result && result.length > 0) {
            widget.IfNoDataFound = result[0].IsNoDataFound;
            resultwid = result[0].widgetid;
            resultcreationtime = result[0].widgetcreationtime;
            lastUpdatedTime = result[0].LastUpdateTime;
          }
          else {
            widget.errorMessage = errorMessages.noWidgetData;
          }
  
          if (resultwid == widget.widgetId 
              && resultcreationtime == widget.widgetcreationtime 
              && !widget.IfNoDataFound) {
            widget.dataLoaded = false;         
            widget.errorMessage = null;

            //Filter data based on active / in active selection of putwall
            result = result.filter(x => {
              return  (x.PutwallActiveFlag &&
                  x.PutwallActiveFlag.toLowerCase() == criteria.WaveStatusActive.toLowerCase());
            });
  
            switch(criteria.WaveStatusType){
              case "INDIVIDUAL PUTWALL" :
                this.loadPutWallStatusIndividual(widget,result);
                break;            
              default :
                this.loadCubbyStatusCombine(widget,result); 
                break;
            }
                  
            this._commonService.lastUpdatedTime = lastUpdatedTime;
          }
  
          if (widget.IfNoDataFound) {
            widget.errorMessage = errorMessages.noWidgetData;
          }         
  
          widget.dataLoaded = true;
        },
        err => {
          console.log("listenFor broadcastCubbyOrderStatus error", err);        
        }
      );
    }
  
    loadCubbyStatusCombine(widget: any,result:any){
      widget.chartOptions = this.PieChartOptions();    
        
      let tmData: any = _.mapValues(
        _.groupBy(result, item => item.Status), x =>
          x.map(y =>
            _.omit(y, [
              "CUSTOMER_ID",
              "FACILITY",
              "PackWaveId",
              "Lastupdate",
              "Wave",
              "WaveDesc",
              "LastUpdate",
              "widgetid",
              "widgetcreationtime",
              "IsNoDataFound",
              "LastUpdateTime"              
            ])
          )
      );
    
      let cubbies = [];
      let colors = [];
      _.forEach(tmData, (x,item,arr) => {        
            let qty = 0;           
            _.forEach(arr[item],(eaArr) => {
              qty = qty + eaArr.Quantity;
            });    

            let color = this.colorCodes.find(x => {return x.status == item.toUpperCase()})
            if(color){
              colors.push(color.color)
            }  
            cubbies.push({name:item,value:qty});                    
      }); 
      
      if(cubbies.length == 0){
        widget.errorMessage = errorMessages.noWidgetData;
        return;
      }    
      
      this.addPieDataSeries(widget.chartOptions, cubbies, "Cubbies", 'pie')   
      if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
        widget.chartOptions.series[0].radius =   ['40%', '55%']; 
        widget.chartOptions.series[0].center =   ['50%', '50%'];       
      }
      widget.chartOptions.color = colors;
      widget.chartOptions.tooltip.formatter = this.pieChartTooltipFormatter;
    }
  
    loadPutWallStatusIndividual(widget: any,result:any){
      widget.chartOptions = this.chartOptions();   
    
      let categoryList = [];    
      let status = [];
      let category = []; 
      let colors = [];
  
      for (let i = 0; i < result.length; i++) {
        if (result[i].Status && result[i].Status != '' && status.indexOf(result[i].Status) == -1) {
          status.push(result[i].Status);
        }
        if (result[i].PutWallName && result[i].PutWallName != '' && categoryList.indexOf(result[i].PutWallName) == -1)  {
          categoryList.push(result[i].PutWallName);
          category.push(result[i].PutWallName + (result[i].PutWallDesc ? '\n' + result[i].PutWallDesc : ''));
        }
      }  
      
      if(status.length == 0 ||  categoryList.length == 0 ){
        widget.errorMessage = errorMessages.noWidgetData;
        return;
      }    
      
      status.forEach(s =>{
        let cubbiesQty = [];      
        categoryList.forEach(c => {
          let itemFound = result.filter(item => {
            return item.PutWallName == c && item.Status == s;
          });
  
          if(itemFound){
            if(itemFound.length > 0){
              let qty = 0;
              itemFound.forEach(q => {
                qty = qty + q.Quantity;
              });
              cubbiesQty.push(qty);
            }          
          }
          else{
            cubbiesQty.push(itemFound.Quantity);
          }      
        });

        let color = this.colorCodes.find(x => {return x.status == s.toUpperCase()})
        if(color){
          colors.push(color.color)
        }  

        this.addDataSeries(widget.chartOptions, cubbiesQty,s, 'bar','a')   
      });
  
      widget.chartOptions.color = colors;
      widget.chartOptions.xAxis.data = category;
      widget.chartOptions.grid.left = '6%';
      widget.chartOptions.grid.bottom = '6%';
      widget.chartOptions.xAxis.axisLabel.rotate = 45;     
      if(category && category.length > 10)    {
        this.addZoomBarEnd(widget.chartOptions,0,30); 
      }
      else {
        this.addZoomBar(widget.chartOptions); 
      }
      if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
        widget.chartOptions.series.forEach(s => {
          s.label = { show: true, position: 'inside'};
        });
      }
    }
  }
  
  
  






// WEBPACK FOOTER //
// ./src/app/services/widgets/cubbystatusdashboard.service.ts